export default __webpack_public_path__ + "static/media/vegan.1b4a98e5.png";